import React, { PureComponent } from 'react';

export const Toggleable = (properties) => (WrapperComponent) =>
	class extends PureComponent {
		state = {
			...properties,
		};

		toggle = (property, value) => {
			this.setState({
				[property]: value,
			});
		};

		enable = (property) => () => {
			this.setState({
				[property]: true,
			});
		};

		disable = (property) => () => {
			this.setState({
				[property]: false,
			});
		};

		switch = (property) => () => {
			this.setState({
				[property]: !this.state[property],
			});
		};

		render() {
			return (
				<WrapperComponent
					{...this.state}
					{...this.props}
					toggleProp={this.toggle}
					enableProp={this.enable}
					disableProp={this.disable}
					switchProp={this.switch}
				/>
			);
		}
	};
